import comp from "./TableRow";
export default comp;
